import { AuthenticatedUser } from '@contexts/Shared';

const mapToUserFront = (user: AuthenticatedUser) => {
  return {
    ...user,
    firstName: getName(user.firstName),
    lastName: getName(user.lastName),
  };
};

const getName = (name) => (name === 'Unknown' ? '' : name);

export { mapToUserFront };
